import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { InfoPageCanvas } from '@/features/app-shell/canvases/info-page-canvas'

export const Route = createFileRoute('/app/privacy')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppPrivacyPage,
})

function AppPrivacyPage() {
  return (
    <AppShell activePath="/app/privacy">
      <InfoPageCanvas kind="privacy" />
    </AppShell>
  )
}
